const columnConfig = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      width: '30px',
      fontWeight: 500,
      textAlign: 'left',
      padding: '.75rem',
    },
    tdClass: 'text-[#333333] p-1',
  },
  {
    key: 'tanggal',
    label: 'Waktu Pengajuan',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 500,
      padding: '.75rem',
    },
    tdStyle: {
      minWidth: '150px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]  p-1',
  },
  {
    key: 'partner',
    label: 'Partner',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 500,
      padding: '.75rem',
    },
    tdStyle: {
      minWidth: '180px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]  p-1',
  },
  {
    key: 'platform',
    label: 'Platform',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'left',
      fontWeight: 500,
      padding: '.75rem',
    },
    tdClass: 'text-left p-1',
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'center',
      fontWeight: 500,
      padding: '.75rem',
    },
    tdClass: 'text-center p-1',
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '80px',
      textAlign: 'center',
      fontWeight: 500,
      padding: '.75rem',
    },
    tdClass: 'text-center p-1',
  },
]

export default columnConfig
